<template>
	<Link
		as="v-card"
		class="flex d-flex flex-column"
		ripple
		link
		:href="$route('reservation.outlets', tenant.id)"
		tag="a"
	>
		<v-img height="250" :src="tenant.cover_url"></v-img>
		<v-card-title primary-title>
			{{ tenant.name }}
		</v-card-title>
		<v-card-text class="fill-height">
			<div class="my-4 text-subtitle-1 text-truncate">
				{{ tenant.price_level }}
			</div>

			<div v-html="tenant.description" v-line-clamp:20="3"></div>
		</v-card-text>
	</Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["tenant"],
};
</script>